import {
  chakra,
  ChakraComponent,
  Checkbox,
  CheckboxProps,
  Flex,
  FlexProps,
  HTMLChakraProps,
} from '@chakra-ui/react';

export const BCLabel: ChakraComponent<
  'label',
  HTMLChakraProps<'label'>
> = chakra('label', {
  baseStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gridColumnGap: 2,
    height: 10,
    bg: 'green.50',
    border: '1px solid',
    borderColor: 'origin.500',
    rounded: 'md',
    px: 3,
    pl: 2,
    py: 1,
    cursor: 'pointer',
    transition: '.2s ease-in-out',
  },
});

export const FlexWrapper: ChakraComponent<'div', FlexProps> = chakra(Flex, {
  baseStyle: () => ({
    alignItems: 'center',
    justifyContent: 'center',
    boxSize: '5',
    border: '2px solid',
    borderColor: 'origin.500',
    borderRadius: 'full',
    bg: 'transparent',
  }),
});

export const IconCheckbox: ChakraComponent<'input', CheckboxProps> = chakra(
  Checkbox,
  {
    baseStyle: () => ({
      w: '6',
      h: '6',
      color: 'white',
      borderRadius: 'full',
    }),
  }
);
